<template>
  <Textfield
    v-model="localValue"
    type="number"
    :prefix="currencyCodeSymbol"
    :append-icon="enableUndo && isPriceDifferentFromPrevPrice ? 'mdi-undo-variant' : undefined"
    :max="max"
    :min="0"
    @click:append="undoToDefaultPrice"
    @blur="priceChanged"
  />
</template>

<script>
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  props: {
    currencyCode: {
      type: String,
      default: 'eur',
    },
    max: {
      type: [String, Number],
      default: null,
    },
    atBlur: {
      type: Boolean,
      default: false,
    },
    enableUndo: {
      type: Boolean,
      default: false,
    },
    previousPrice: {
      type: [String, Number],
      default: undefined,
    },
  },
  computed: {
    currencyCodeSymbol() {
      switch (this.currencyCode) {
        case 'eur':
          return '€';
        default:
          return '€';
      }
    },
    isPriceDifferentFromPrevPrice() {
      if (this.enableUndo) {
        const prevPrice = typeof this.previousPrice === 'string' ? parseFloat(this.previousPrice) : this.previousPrice;
        const currentPrice = typeof this.localValue === 'string' ? parseFloat(this.localValue) : this.localValue;

        // Check if both values are valid numbers and if they are different
        if (!isNaN(prevPrice) && !isNaN(currentPrice))
          return Number(prevPrice.toFixed(6)) !== Number(currentPrice.toFixed(6));
      }

      return undefined;
    }
  },
  methods: {
    undoToDefaultPrice() {
      if (this.enableUndo)
        this.localValue = this.previousPrice;
    },
    priceChanged() {
      if (this.atBlur) {
        this.$emit('blur');
      }
      if (this.isPriceDifferentFromPrevPrice) {
        this.$emit('price-changed');
      }
    }
  }
};
</script>

<style lang="css" scoped>
</style>